import { computed, shallowRef, watch, type ComputedRef } from 'vue'

import { useDocumentHidden } from '@/composables/useDocumentHidden'
import { type ActivitySources, tabActivity, unseenSources } from '@/lib/activity/tab-activity'
import type { Activity } from '@/types/activity'

/** What the browser tab shows for background work: work in flight, and an outcome that arrived while the tab was hidden until the founder returns. */
export function useTabActivity(sources: () => ActivitySources): ComputedRef<Activity> {
  const hidden = useDocumentHidden()
  const unseen = shallowRef<ReadonlySet<string>>(new Set())

  watch(
    [sources, hidden],
    ([current, isHidden]) => {
      unseen.value = unseenSources(current, isHidden, unseen.value)
    },
    { immediate: true },
  )

  return computed(() => tabActivity(sources(), unseen.value))
}
